<template>
  <div v-if="vat">
    <h1>Vat action</h1>
    <v-btn :to="{ name: 'vatActions' }">
      <v-icon>chevron_left</v-icon>Vat actions
    </v-btn>
    <div class="boxPayload">
      <h2>Id number</h2>
      <div>{{ vat.id }}</div>
    </div>
    <div class="boxPayload">
      <h2>Vat registration number</h2>
      <div>{{ vat.vrn }}</div>
    </div>
    <div class="boxPayload">
      <h2>Test</h2>
      <div>{{ vat.test }}</div>
    </div>
    <div class="boxPayload">
      <h2>Test scenario</h2>
      <div>{{ vat.testScenario }}</div>
    </div>
    <div class="boxPayload">
      <h2>Action</h2>
      <div>{{ vat.action }}</div>
    </div>
    <div class="boxPayload">
      <h2>Payload that was sent to HMRC</h2>
      <div v-for="(payloadValue, payloadKey) in vat.payload" :key="payloadKey">
        {{ payloadKey }}: {{ payloadValue }}
      </div>
    </div>
    <div class="boxPayload">
      <h2>Response</h2>
      <div class="divResponse">{{ JSON.stringify(vat.response, null, 2) }}</div>
    </div>
    <div class="boxPayload">
      <h2>User</h2>
      <EntityZ v-if="vat.user" :entity="vat.user" format="system" />
    </div>
    <div class="boxPayload">
      <h2>Timestamp</h2>
      {{ vat.timestamp | formatDateTime }}
    </div>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import VAT from "@/graphql/accounts/vat/Vat";
export default {
  name: "VatAction",
  metaInfo() {
    return {
      title: "Vat action",
      titleTemplate: "%s - Accounts - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityZ
  },
  apollo: {
    vat: {
      query: VAT,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      fetchPolicy: "cache-and-network"
    }
  }
};
</script>

<style>
.boxId {
  font-size: 1.5em;
  font-weight: bold;
}

.boxName {
  font-size: 3em;
  font-weight: bold;
}

.boxPayload {
  border: 1px solid gray;
  padding: 15px;
  margin-top: 15px;
}

.divResponse {
  white-space: pre-wrap;
}
</style>